import {
  FieldValues,
  UseFormProps,
  useForm as useRHForm,
} from 'react-hook-form';

export function useForm<TFieldValues extends FieldValues = FieldValues>(
  props: UseFormProps<TFieldValues> = {},
) {
  const formReturn = useRHForm<TFieldValues>({
    reValidateMode: 'onChange',
    mode: 'all',
    ...props,
  });

  return {
    visibleErrors: formReturn.formState.errors,
    ...formReturn,
  };
}
